import {TimelineMax, TweenLite, Linear} from 'gsap';
const eventemitter3 = require('eventemitter3');

const state = {
    progress: 0,        // Current left shift relative value
    shift: 0,           // Initial shift relative value
    velocity: 70,       // Current spatial velocity
    velocityAbs: 70,    // Current spatial velocity absolute value
    sign: 1,            // Current direction
    delta: 100,          // Pattern width - period,
    wrapTotalShift: 0
};
let tl;

function init(periodWidth) {
    state.delta = periodWidth || 100;

    tl = new TimelineMax({
        paused: true,
        onUpdate: () => {
            WM.emit('update', state.progress, getAbsoluteShift());
        },
        onComplete: () => {
            tl.restart();
        },
        onReverseComplete: () => {
            tl.reverse(0);
        }
    });
    tl.to(state, 10, {progress: 1, ease: Linear.easeInOut});
    if (state.velocityAbs > 0)
        tl.duration(state.delta / state.velocityAbs);

    return this;
}

function reset() {
    tl.seek(0);
    return this;
}

function start() {
    _updateVelocity();
    this.resume();
    return this;
}

function pause() {
    if (!state.playing) return;
    state.playing = false;
    tl.pause();
    return this;
}

function paused() {
    return !state.playing;
}

function resume() {
    if (state.playing) return;
    state.playing = true;
    tl.resume();
    return this;
}

function _updateDuration() {
    if (state.sign === 0) return;
    tl.duration(state.delta / state.velocityAbs);
}

function _updateDirection(prevSign, sign) {
    if (prevSign !== sign) {
        switch (sign) {
            case 0:
                tl.pause();
                break;
            case 1:
                if (tl.reversed())
                    tl.play();
                if (!state.playing)
                    tl.pause();
                break;
            case -1:
                if (!tl.reversed()) {
                    tl.reverse();
                }
                if (!state.playing)
                    tl.pause();
                break;
        }
    }
}

function _updateVelocity() {
    const prevSign = state.sign;
    const v = state.velocity;
    state.velocityAbs = Math.abs(v);
    state.sign = v !== 0 ? v / Math.abs(v) : 0;
    _updateDuration();
    _updateDirection(prevSign, state.sign)
}

function getVelocity() {
    return state.velocity;
}

function setVelocity(value) {
    state.velocity = value;
    _updateVelocity();
    return value;
}

function changeVelocityTo(value) {
    TweenLite.to(state, 1, {
        velocity: value,
        onUpdate: () => {
            _updateVelocity();
        }
    });
    return this;
}

function setDeltaWidth(value) {
    state.delta = value;
    _updateDuration();
    return value;
}

function normaliseShift(value) {
    return value - Math.floor(value);
}

function setShift(value) {
    state.shift = normaliseShift(value - state.progress);
    return value;
}

function getAbsoluteShift() {
    return (state.shift + state.progress) * state.delta;
}

function setWrapTotalShift(value) {
    state.wrapTotalShift = value;
}

function getWrapTotalShift() {
    return state.wrapTotalShift;
}


const WM = new eventemitter3();
WM.init = init.bind(WM);
WM.start = start.bind(WM);
WM.reset = reset.bind(WM);
WM.pause = pause.bind(WM);
WM.paused = paused.bind(WM);
WM.resume = resume.bind(WM);
WM.getVelocity = getVelocity.bind(WM);
WM.setVelocity = setVelocity.bind(WM);
WM.changeVelocityTo = changeVelocityTo.bind(WM);
WM.setDeltaWidth = setDeltaWidth.bind(WM);
WM.setShift = setShift.bind(WM);
WM.getAbsoluteShift = getAbsoluteShift.bind(WM);
WM.setWrapTotalShift = setWrapTotalShift.bind(WM);
WM.getWrapTotalShift = getWrapTotalShift.bind(WM);

module.exports = WM;


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/BOSSWatermarkSingleton.js